import {
    useCoursesForCartUpsellByIds,
    useFetchBundleFromCourse,
    type CourseForCartUpsell,
} from '@udemy/react-certification-preparation';
import {useExamByTopicId} from '@udemy/react-certification-vouchers';

export interface OtherCourseInBundle {
    course: CourseForCartUpsell | null;
    isLoading: boolean;
    error: Error | null;
}

export function useBundleForCourseUpsell(inCartCourseId: number) {
    const {bundle, isLoading: bundleLoading} = useFetchBundleFromCourse(inCartCourseId, {
        enabled: !!inCartCourseId,
    });
    const relatedTopicId = bundleLoading ? undefined : bundle?.topicId;
    const examInTopic = useExamByTopicId(relatedTopicId);

    const otherCourseEntry =
        !bundleLoading && bundle?.contents.find((c) => c.id !== inCartCourseId);
    const {courses, isLoading, error} = useCoursesForCartUpsellByIds(
        otherCourseEntry ? [otherCourseEntry.id] : [],
    );
    // `useCoursesForCartUpsellByIds([])` still reports isLoading:true — treat
    // no-other-course as settled so downstream gates don't hang.
    const otherCourseInBundle: OtherCourseInBundle = {
        course: courses[0] ?? null,
        isLoading: bundleLoading || (otherCourseEntry ? isLoading : false),
        error,
    };

    return {
        bundle,
        bundleLoading,
        relatedTopicId,
        examInTopic,
        hasBundle: !bundleLoading && Boolean(bundle),
        hasVoucherForTopic: Boolean(examInTopic.voucherPool ?? examInTopic.defaultPool),
        otherCourseInBundle,
    };
}
